export class SubscriptionHolder {
    constructor() {
        this._subscriptions = [];
    }
    push(subscription) {
        this._subscriptions.push(subscription);
    }
    unsubscribe() {
        for (const sub of this._subscriptions) {
            sub.unsubscribe();
        }
        this._subscriptions = [];
    }
}
//# sourceMappingURL=SubscriptionHolder.js.map